__turbopack_context__.v({
  "breadcrumbRow": "plp-module-scss-module__5O809W__breadcrumbRow",
  "hasPlpBanner": "plp-module-scss-module__5O809W__hasPlpBanner",
  "heroSection": "plp-module-scss-module__5O809W__heroSection",
  "loadingContainer": "plp-module-scss-module__5O809W__loadingContainer",
  "noPlpBanner": "plp-module-scss-module__5O809W__noPlpBanner",
  "onlyMerchBoxes": "plp-module-scss-module__5O809W__onlyMerchBoxes",
  "onlyPlpBanner": "plp-module-scss-module__5O809W__onlyPlpBanner",
  "plpContainer": "plp-module-scss-module__5O809W__plpContainer",
  "productTagInfoBannerContainer": "plp-module-scss-module__5O809W__productTagInfoBannerContainer",
  "resultsContainer": "plp-module-scss-module__5O809W__resultsContainer",
});
